/*
 * @author Sanford Whiteman
 * @version v1.104
 * @license MIT License: This license must appear with all reproductions of this software.
 *
 * Create a completely barebones, user-styles-only Marketo form
 * by removing inline STYLE attributes and disabling STYLE and LINK elements
 */
export const destyleMktoForm = (mktoForm, moreStyles) => {
  const formEl = mktoForm.getFormElem()[0],
    arrayify = getSelection.call.bind([].slice);

  // remove element styles from <form> and children
  const styledEls = arrayify(formEl.querySelectorAll('[style]')).concat(formEl);
  styledEls.forEach(function (el) {
    el.removeAttribute('style');
  });

  // disable remote stylesheets and local <style>s
  const styleSheets = arrayify(document.styleSheets);
  styleSheets.forEach(function (ss) {
    if (
      [mktoForms2BaseStyle, mktoForms2ThemeStyle].indexOf(ss.ownerNode) != -1 ||
      formEl.contains(ss.ownerNode)
    ) {
      ss.disabled = true;
    }
  });

  if (!moreStyles) {
    formEl.setAttribute('data-styles-ready', 'true');
  }
};

export const checkAndSubmitMktoForm = form => {
  let formEl = form.getFormElem()[0];
  let honeypot = formEl.querySelector('input[name=confirmtxt]');
  // Check if the honeypot field is empty
  if (!honeypot || honeypot.value == '') {
    // Not a spam bot! Submit the form
    form.submittable(true);
  } else {
    // This is a spam bot! Don’t submit the form
    form.submittable(false);
  }
};

export const loadMarketoFormsJs = async () => {
  if (window.MktoForms2) return Promise.resolve();

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.onload = () => {
      resolve();
    };
    script.onerror = () => {
      resolve(); // Resolving, as we don't want the whole header to fail if Marketo is down.
    };
    script.src = 'https://pages.skydio.com/js/forms2/js/forms2.min.js';
    document.head.appendChild(script);
  });
};
